import { Box, TableCell, TableSortLabel } from "@mui/material";

import { visuallyHidden } from '@mui/utils';

export default function EnhancedTableHead({ headers, orderBy, order, handleRequestSort }) {

  return (
    <>
      {
        headers.map((headCell) => (
          <TableCell
            key={headCell.value}
            align={'center'}
            sx={headCell.value === 'email' && {width: '20'}}
            // padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.value}
              direction={orderBy === headCell.value ? order : 'asc'}
              onClick={() => handleRequestSort(headCell.value)}
            >
              {headCell.label}
              {orderBy === headCell.value ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))
      }
    </>
  );




}